<template>
  <div class="w-full flex flex-col justify-start items-center">
    <SelectedFiltersLocationBar :products="products" />
    <div
      class="flex flex-col lg:flex-row flex-wrap gap-2"
    >
      <Card v-for="product in filteredProducts" :key="product.id" :product="product" />
    </div>
  </div>
</template>

<script>
import Card from './helpers/card.vue' 
import SelectedFiltersLocationBar from './helpers/selected-filters-location-bar.vue'

export default {
  components: {
    Card,
    SelectedFiltersLocationBar
  },
  props: {
    products: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      filteredProducts: [],
      selectedFilters: []
    }
  },
  created () {
    this.$bus.$on('filteredProducts', (val) => {
      this.filteredProducts = val
    })
    this.$bus.$on('selectedFilters', (val) => {
      this.selectedFilters = val
    })
    this.filteredProducts = this.products
  },
  beforeDestroy() {
    this.$bus.$off('filterProductsBy')
    this.$bus.$off('selectedFilters')
  }
}
</script>
